<ngx-charts-chart [view]="[width, height]" [showLegend]="false" [animations]="animations">
  <svg:g *ngIf="dims" [attr.transform]="transform" class="line-chart chart">
    <svg:g
      ngx-charts-x-axis
      [xScale]="xScale"
      [dims]="dims"
      [showGridLines]="true"
      [showLabel]="false"
      [trimTicks]="true"
      [rotateTicks]="false"
      (dimensionsChanged)="updateXAxisHeight($event)"
    ></svg:g>
    <svg:g
      ngx-charts-y-axis
      [yScale]="yScale"
      [dims]="dims"
      [showGridLines]="true"
      [showLabel]="!!yAxisLabel"
      [labelText]="yAxisLabel"
      (dimensionsChanged)="updateYAxisWidth($event)"
    ></svg:g>

    <svg:g
      ngx-charts-line-series
      [xScale]="xScale"
      [yScale]="yScale"
      [colors]="colors"
      [data]="dataSerie"
      [scaleType]="scaleType"
      [curve]="curve"
      [animations]="animations"
    ></svg:g>

    <svg:circle
      *ngFor="let punto of series"
      [attr.cx]="xScale(punto.name)"
      [attr.cy]="yScale(punto.value)"
      r="4"
      [attr.fill]="coloreOsservazione(punto.riskClass)"
      stroke="#fff"
      stroke-width="1"
    >
      <title>{{ titoloOsservazione(punto) }}</title>
    </svg:circle>
  </svg:g>
</ngx-charts-chart>
